define([
    "dojo/_base/declare",
    "csi/html",
    "csi/view/ToolbarPluginSwitchboard"
], function(declare,html,ToolbarPluginSwitchboard) {

    return declare(ToolbarPluginSwitchboard, {
        idViewProperty: "activeProductSalesRegion",
        placeHolder: "SelectOne",
        resDefault: "",

        canShowPlugin: function() {
            // summary: return true if there is at least one ProductSalesRegion
            // Disable the individual view's ProductSalesRegion selector when these views are being displayed in the composite TDS view.
            return !this._isUnderTDSView() && this.store && this.store.isLoaded() && (this.store.query().length > 1);
        },

        postCreate: function() {
            this.inherited(arguments);

            // remove button action
            html.setVisible(this.buttonNode, false);
            html.setVisible(this.labelNode, true);
        },

        onChangeItem: function(/*csi.view.Widget*/view, /*Node*/node) {
            // summary: do nothing - idViewProperty handles it all
        },

        validatePlugin: function(/*Context*/ctx) {
            // summary: hide if printing
            return !ctx.bPrint;
        },

        _isUnderTDSView: function() {
            // Return boolean if the view sub-view under the TDS composite view
            var parentView = this.getView().viewParent;
            return (parentView && parentView.defView.m_id == "TDS");
        }
    });
});